module.exports = __webpack_public_path__ + "static/img/logo_31.98751b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_31.png
// module id = u/tS
// module chunks = 1